export default __webpack_public_path__ + "static/media/BootcampLogo.12fca1a6.svg";